import { Routes, Route } from "react-router-dom";
import Login from "./components/auth/login";
import Genesis from "./components/auth/genesis";
import "./App.css";
import VerifyCode from "./components/auth/verify-code";
import ForgotPassword from "./components/auth/forgot-password";
import Register from "./components/auth/register";
import ForgotPasswordVerify from "./components/auth/forgot-password-verify";
import { connect, useDispatch } from "react-redux";
import NewApplication from "./components/application/NewApplication";
import ApplicationList from "./components/application/ApplicationList";
import ApplicationDetail from "./components/application/ApplicationDetail";
import ApplicationResultList from "./components/application/ApplicationResultList";
import FileUpload from "./components/application/FileUpload";
import SelectDoctor from "./components/application/SelectDoctor";
import Payment from "./components/application/Payment";
import PatientRegister from "./components/auth/patient-register";
import Index from "./components/static/Index";
import TriageEdit from "./components/application/TriageEdit";
import HTMLRenderer from "./components/HTMLRenderer";
import SelectFacility from "./components/SelectFacility";
import SelectFacilityForList from "./components/SelectFacilityForList";
import NewApplicationV2 from "./components/v3/NewApplicationV2";
import FileUploadV2 from "./components/v3/FileUploadV2";
import PagingApplications from "./components/v3/PagingApplications";
import PaymentV2 from "./components/v3/PaymentV2";
import Dashboard from "./components/doctor/Dashboard";
import ApplicationDetailDoctor from "./components/doctor/ApplicationDetailDoctor";
import ApplicationDetailV2 from "./components/v3/ApplicationDetailV2";
import ConcludedApplications from "./components/v3/ConcludedApplications";
import SelectFacilityForConcluded from "./components/SelectFacilityForConcluded";
import ConcludedApplicationDetail from "./components/v3/ConcludedApplicationDetail";
import CreateApplicationReport from "./components/doctor/CreateApplicationReport";
import NurseDashboard from "./components/nurse/Dashboard";
import NoteDetail from "./components/nurse/NoteDetail";
import EditCareProvider from "./components/nurse/EditCareProviderData";
import ApplicationNote from "./components/application/ApplicationNote";
import RequestAndSuggestions from "./components/RequestAndSuggestions";
import Survey from "./components/application/Survey";
import Empty from "./components/application/Empty";
import React, { Suspense, useEffect } from "react";
import { logOut } from "./actions/auth/login";
import { ConfigProvider } from "antd";
import { commonThemeSettings } from "./theme";
import GenesisVerify from "./components/auth/gensis-verify";
import ErrorBoundary from "./components/ErrorBoundary";
import trTR from "antd/locale/tr_TR";
import { FacilityProvider } from "./context/FacilityContext";
import "./i18n";

import("preline");

function App(props) {
  const dispatch = useDispatch();
  const accessToken = localStorage.getItem("accessToken");

  // Token süresi dolmuş mu kontrol eden fonksiyon
  const isTokenExpired = (token) => {
    try {
      const payload = JSON.parse(atob(token.split(".")[1])); // Token payload'ı çözümleme
      const expirationTime = payload.exp * 1000; // exp değeri milisaniyeye çeviriyoruz
      return Date.now() > expirationTime; // Süre dolmuşsa true döner
    } catch (error) {
      console.error("Token çözümleme hatası:", error);
      return true; // Token geçersizse süresi dolmuş gibi davran
    }
  };

  useEffect(() => {
    if (accessToken && isTokenExpired(accessToken)) {
      dispatch(logOut()); // Süresi dolmuşsa çıkış yap
    }
  }, [accessToken, dispatch]);

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <ErrorBoundary>
        <ConfigProvider locale={trTR} theme={commonThemeSettings}>
          <FacilityProvider>
            <div className="App">
              <Routes>
                <Route path="/" element={<Index />}></Route>
                <Route path="/login" element={<Login />}></Route>
                <Route path="/register-phone" element={<Genesis />}></Route>
                <Route path="/verify-code" element={<VerifyCode />}></Route>
                <Route path="/register" element={<Register />}></Route>
                <Route
                  path="/patient-register"
                  element={<PatientRegister />}
                ></Route>
                <Route
                  path="/forgot-password"
                  element={<ForgotPassword />}
                ></Route>
                <Route
                  path="/forgot-password-verify"
                  element={<ForgotPasswordVerify />}
                ></Route>
                <Route
                  path="/gensis-verify"
                  element={<GenesisVerify />}
                ></Route>
                <Route
                  path="/select-facility"
                  element={<SelectFacility />}
                ></Route>
                <Route
                  path="/new-application/:FacilityId"
                  element={<NewApplication />}
                ></Route>
                <Route path="/empty" element={<Empty />}></Route>
                <Route path="/edit-triage/:Id" element={<TriageEdit />}></Route>
                <Route
                  path="/applications"
                  element={<ApplicationList />}
                ></Route>
                <Route path="/file-upload/:Id" element={<FileUpload />}></Route>
                <Route
                  path="/select-doctor/:Id"
                  element={<SelectDoctor />}
                ></Route>
                <Route path="/payment/:Id" element={<Payment />}></Route>
                <Route
                  path="/application-detail/:Id"
                  element={<ApplicationDetail />}
                ></Route>
                <Route
                  path="/application-results"
                  element={<ApplicationResultList />}
                ></Route>
                <Route path="/checkout" element={<HTMLRenderer />}></Route>
                <Route
                  path="/select-facility-for-list"
                  element={<SelectFacilityForList />}
                ></Route>
                <Route
                  path="/new-applicationv2"
                  element={<NewApplicationV2 />}
                ></Route>
                <Route
                  path="/file-uploadv2/:Id"
                  element={<FileUploadV2 />}
                ></Route>
                <Route
                  path="/applicationsv2"
                  element={<PagingApplications />}
                ></Route>
                <Route path="/paymentv2/:Id" element={<PaymentV2 />}></Route>
                <Route path="/dashboard" element={<Dashboard />}></Route>
                <Route
                  path="/application-detial-doctor/:Id"
                  element={<ApplicationDetailDoctor />}
                />
                <Route
                  path="/application-detail-user/:Id"
                  element={<ApplicationDetailV2 />}
                ></Route>
                <Route
                  path="/concluded-applications"
                  element={<ConcludedApplications />}
                ></Route>
                <Route
                  path="/select-facility-for-concluded"
                  element={<SelectFacilityForConcluded />}
                ></Route>
                <Route
                  path="/concluded-application-detail/:Id"
                  element={<ConcludedApplicationDetail />}
                ></Route>
                <Route
                  path="/create-application-report/:Id"
                  element={<CreateApplicationReport />}
                ></Route>
                <Route
                  path="/nurse-dashboard"
                  element={<NurseDashboard />}
                ></Route>
                <Route
                  path="/note-detail/:Id/:patientName"
                  element={<NoteDetail to="/" />}
                />
                <Route
                  path="/edit-care-provider/:Id/:Target"
                  element={<EditCareProvider />}
                ></Route>
                <Route
                  path="/application-note/:Id"
                  element={<ApplicationNote />}
                ></Route>
                <Route
                  path="/requests-and-suggestions"
                  element={<RequestAndSuggestions />}
                ></Route>
                <Route path="/survey" element={<Survey />}></Route>
              </Routes>
            </div>
          </FacilityProvider>
        </ConfigProvider>
      </ErrorBoundary>
    </Suspense>
  );
}

const mapStateToProps = (state) => {
  return state;
};
const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(App);
